import ChartGroups from "./ChartGroups";

export default function Charts() {  
   
    return (
      <div>
            <ChartGroups />
      </div>
    );
  }
  